import { type FC } from 'react';
import { useIntl } from 'dibs-react-intl';
import {
    LOCALE_US,
    LOCALE_DE,
    LOCALE_FR,
    LOCALE_PSEUDO,
    LOCALE_DEBUG,
    LOCALE_IT,
    LOCALE_ES,
} from 'dibs-intl/exports/locales';
import Logo from 'dibs-icons/exports/Logo';

import { hasKey } from 'dibs-ts-utils/exports/hasKey';

const logoLookup = {
    [LOCALE_PSEUDO]: '40PC_HorizontalEn',
    [LOCALE_DEBUG]: '40PC_HorizontalEn',
    [LOCALE_US]: '40PC_HorizontalEn',
    [LOCALE_DE]: '40PC_HorizontalDe',
    [LOCALE_FR]: '40PC_HorizontalFr',
    [LOCALE_IT]: '40PC_HorizontalIt',
    [LOCALE_ES]: '40PC_HorizontalEs',
} as const;

export const LocalizedLogoVipIcon: FC = () => {
    const { locale } = useIntl();

    const variation = hasKey(logoLookup, locale) ? logoLookup[locale] : '40PC_HorizontalEn';

    return (
        <Logo
            variation={variation}
            dataTn="logo-vip"
            role="img"
            ariaLabel="1stDibs Private Client"
        />
    );
};
